<template>
  <h1 v-if="level === 1" :class="`${align} ${size ? 'size-x' + size : ''}`">
    {{ text }}
  </h1>

  <h2 v-else-if="level === 2" :class="`${align} ${size ? 'size-x' + size : ''}`">
    {{ text }}
  </h2>
</template>

<script>
import { existsInArray } from '@/helpers';

export default {
  name: 'Heading',
  props: {
    level: {
      default: 1,
      type: Number,
      validator: (value) => existsInArray(value, [1, 2]),
    },
    text: {
      required: true,
      type: String,
    },
    align: {
      default: 'justify',
      type: String,
      validator: (value) => existsInArray(value, ['justify', 'center', 'left', 'right']),
    },
    size: {
      default: null,
      type: Number,
      validator: (value) => existsInArray(value, [1, 2, 3]),
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/typography';
@import '../scss/variables';

$sizes: 1.5, 1.8;

%heading-base {
  font-weight: $bold-font;
}

h1,
h2 {
  @extend %heading-base;
  @extend %align;
}

h1 {
  @include getSizes($heading-primary-size, $heading-primary-line-height, $sizes);
}

h2 {
  @include getSizes($heading-secondary-size, $heading-secondary-line-height, $sizes);
}
</style>



// WEBPACK FOOTER //
// src/components/Heading.vue